'use strict';

const ANNOUNCEMENT = 'announcement';
const RELEASE_NOTE = 'release-note';
const CATEGORY_CHOICES = [ANNOUNCEMENT, RELEASE_NOTE];

class AnnouncementCategory {
    constructor(name) {
        this._name = name;
    }

    static getChoices() {
        return CATEGORY_CHOICES;
    }

    static getAnnouncementName() {
        return ANNOUNCEMENT;
    }

    static getReleaseNoteName() {
        return RELEASE_NOTE;
    }

    isAnnouncement() {
        return this._name === AnnouncementCategory.getAnnouncementName();
    }

    isReleaseNote() {
        return this._name === AnnouncementCategory.getReleaseNoteName();
    }

    getName() {
        return this._name;
    }
}

module.exports = AnnouncementCategory;



// WEBPACK FOOTER //
// ./feedback/domain/value/announcement-category.js